// extracted by mini-css-extract-plugin
module.exports = {"appWrapper":"App_appWrapper__2lg95","intlSelect":"App_intlSelect__1XIcw"};